import { CostAccountingDairenArray } from '../../../types/costAccountingDairen/CostAccountingGetResponse';
import { formatProjectName } from '../../../utils/formatProjectName';

interface RenderCostAccountingDairenRowProps {
  item: CostAccountingDairenArray;
}

const RenderCostAccountingDairenRow = ({
  item,
}: RenderCostAccountingDairenRowProps) => {
  return (
    <>
      <td>{item.projectNo}</td>
      <td>{formatProjectName(item.projectName)}</td>
      <td>{new Date(item.startDate).toLocaleDateString('ja-JP')}</td>
      <td>{new Date(item.endDate).toLocaleDateString('ja-JP')}</td>
      <td>{item.manHour}</td>
      <td>
        {Number(item.manHoursCostGen).toLocaleString('zh-CN', {
          maximumFractionDigits: 2,
        })}
      </td>
      <td>
        {Number(item.manHoursCostYenMonthEnd).toLocaleString('ja-JP', {
          maximumFractionDigits: 2,
        })}
      </td>
      <td>
        {Number(item.manHoursCostYenMonthAverage).toLocaleString('ja-JP', {
          maximumFractionDigits: 2,
        })}
      </td>
      <td>
        {Number(item.manHoursCostYenTotalAverage).toLocaleString('ja-JP', {
          maximumFractionDigits: 2,
        })}
      </td>
    </>
  );
};

export default RenderCostAccountingDairenRow;
